<div>
  <ng-container *ngIf="!isPrinterIgnored">
    <button (click)="requestDevice()">Buscar impresora</button><br>
    <button (click)="printLines()">Impresora</button><br>
    <button (click)="openDrawer()">Abrir portamonedas</button><br>
    <button (click)="cutPaper()">Cortar papel</button><br>
    <button *ngIf="isConnected" (click)="ignorePrinter()">Ignorar impresora</button><br>
  </ng-container>

  <ng-container *ngIf="isPrinterIgnored">
    <button (click)="resetPrinterIgnore()">Conectar impresora</button><br>
    <button class="ignored-printer-btn">Impresora Ignorada</button><br>
  </ng-container>
</div>

<!-- Modal para preguntar si desea ignorar la impresora -->
<div *ngIf="showPrinterModal" class="printer-modal-overlay">
  <div class="printer-modal">
    <h3>Impresora no encontrada</h3>
    <p>No se ha detectado ninguna impresora conectada. ¿Desea ignorar la impresora?</p>
    <div class="printer-modal-buttons">
      <button (click)="ignorePrinter()">Ignorar impresora</button>
      <button (click)="closePrinterModal()">Cancelar</button>
    </div>
  </div>
</div>
